import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "status"];
  static values = {
    success: { type: String, default: "网页地址已复制。" },
    fallback: { type: String, default: "请手动复制已选中的网页地址。" }
  };

  connect() { this.abort = new AbortController(); }
  disconnect() { this.abort.abort(); }
  clearStatus() { this.statusTarget.textContent = ""; }

  async copy() {
    const signal = this.abort.signal;
    try {
      await navigator.clipboard.writeText(this.inputTarget.value);
      if (!signal.aborted) this.statusTarget.textContent = this.successValue;
    } catch {
      if (signal.aborted) return;
      this.inputTarget.focus();
      this.inputTarget.select();
      if (this.inputTarget instanceof HTMLTextAreaElement) {
        this.inputTarget.setSelectionRange(0, this.inputTarget.value.length);
      }
      this.statusTarget.textContent = this.fallbackValue;
    }
  }
}
